import ouiStyle from '@goldwasserexchange/oui-style';
import ouiDom from '@goldwasserexchange/oui-dom';
import * as React from 'react';
import { ControlersSection } from './ControllersSection';
import { LegalProtectionSection } from './LegalProtectionSection';
import { OtherProtectionsSection } from './OtherProtections';

export const LegalInfoSection = () => {
  const [heights, setHeight] = React.useState([0, 0, 0]);
  const height = Math.max(...heights);
  return (
    <ouiDom.HeadingSection.HeadingSection
      index={6}
      name="LegalInfoSection"
      paddingTop={4}
      paddingBottom={4}
      paddingHorizontal="simple"
      container={ouiStyle.Constants.Container.full}
      innerContainer={ouiStyle.Constants.Container.xl}
      innerDisplay={ouiStyle.Constants.DisplayProp.flex}
      innerFlexDirection={[ouiStyle.Constants.InFlexDirectionProp.col, undefined, undefined, ouiStyle.Constants.InFlexDirectionProp.row, undefined, undefined]}
      innerAlignItems={ouiStyle.Constants.AlignItemsProp.stretch}
      innerJustifyContent={ouiStyle.Constants.JustifyContentProp.between}
      backgroundColor={ouiStyle.Constants.Colors.fade}
    >
      <LegalProtectionSection
        index={0}
        widthLines={['full', undefined, undefined, '1/4', undefined, undefined]}
        titleBarHeight={height}
        setTitleBarHeight={setHeight}
      />
      <OtherProtectionsSection
        index={1}
        widthLines={['full', undefined, undefined, '2/4', undefined, undefined]}
        titleBarHeight={height}
        setTitleBarHeight={setHeight}
      />
      <ControlersSection
        index={2}
        widthLines={['full', undefined, undefined, '1/4', undefined, undefined]}
        titleBarHeight={height}
        setTitleBarHeight={setHeight}
      />
    </ouiDom.HeadingSection.HeadingSection>
  );
};
